import { TermsOfUseProps } from "@/lib/types";
import {
  UserCheck,
  Briefcase,
  CircleOff,
  Gavel,
  Copyright,
  ShieldCheck,
} from "lucide-react";

export const termsData: TermsOfUseProps[] = [
  {
    id: "1",
    title: "User Agreement",
    description:
      "By accessing Octarnal, you confirm you are at least 18 years old. You agree to provide accurate information and maintain the confidentiality of your relationship with our digital solutions.",
    icon: UserCheck,
    span: "lg:col-span-8 md:col-span-7 col-span-12",
  },
  {
    id: "2",
    title: "Account Security",
    description:
      "You are responsible for safeguarding your access credentials. Notify us immediately of any unauthorized use.",
    icon: ShieldCheck,
    span: "lg:col-span-4 md:col-span-5 col-span-12",
  },
  {
    id: "3",
    title: "Service Scope",
    description:
      "Octarnal provides premium software development, branding, and digital strategy. We reserve the right to modify services to ensure top-tier quality.",
    icon: Briefcase,
    span: "lg:col-span-4 md:col-span-6 col-span-12",
  },
  {
    id: "4",
    title: "Intellectual Property",
    description:
      "All code, designs, and content produced by Octarnal remain our property unless explicitly transferred via written contract.",
    icon: Copyright,
    span: "lg:col-span-4 md:col-span-6 col-span-12",
  },
  {
    id: "5",
    title: "Termination",
    description:
      "We may suspend access to our platform for violations of these terms without prior notice or liability.",
    icon: CircleOff,
    span: "lg:col-span-4 md:col-span-6 col-span-12",
  },
  {
    id: "6",
    title: "Governing Law",
    description:
      "These terms are governed by the laws of the People's Republic of Bangladesh. Any disputes shall be settled in the courts of Dhaka.",
    icon: Gavel,
    span: "lg:col-span-12 md:col-span-6 col-span-12",
  },
];
